import { render } from "./AposInputSelect.vue?vue&type=template&id=6a10facb"
import script from "./AposInputSelect.vue?vue&type=script&lang=js"
export * from "./AposInputSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"schema/ui/apos/components/AposInputSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a10facb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a10facb', __exports__)) {
    api.reload('6a10facb', __exports__)
  }
  
  module.hot.accept("./AposInputSelect.vue?vue&type=template&id=6a10facb", () => {
    api.rerender('6a10facb', render)
  })

}


export default __exports__